import { Query } from "components/common"
import { FETCH_PAGE } from "lib/graphql/queries"

export default ({letterId}) => (
	<Query
		query={FETCH_PAGE}
		options={{variables: { query: `id:${letterId}` }}}
	>
		{({cms: { pages: { items: [page] } } }) => (
			<>
				<h2 className="title">{page.metaTitle}</h2>
				<div className="description" dangerouslySetInnerHTML={{ __html: page.content }} />
			</>
		)}
	</Query>
)
